import { ElementType, useContext, useEffect, useRef } from 'react';

import { Box, BoxProps, Typography, TypographyProps } from '@mui/material';

import { OverflowCounterContext } from './context';

type OverflowItemProps = {
  overflowKey: string | number;
};

const useObserveItem = () => {
  const observer = useContext(OverflowCounterContext);
  const itemRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (!observer) {
      throw new Error('Overflow item must be used inside OverflowCounter');
    }
    return observer.observeElement(itemRef.current!);
  }, [observer]);
  return itemRef;
};

type OverflowItemBoxProps = BoxProps & OverflowItemProps;
export const OverflowItemBox = ({
  overflowKey,
  ...props
}: OverflowItemBoxProps) => {
  const itemRef = useObserveItem();
  return <Box ref={itemRef} data-overflowkey={overflowKey} {...props} />;
};

type OverflowItemTypographyProps<C extends ElementType> = TypographyProps<
  C,
  { component?: C }
> &
  OverflowItemProps;
export const OverflowItemTypography = <C extends ElementType>({
  overflowKey,
  ...props
}: OverflowItemTypographyProps<C>) => {
  const itemRef = useObserveItem();
  return <Typography ref={itemRef} data-overflowkey={overflowKey} {...props} />;
};
